import React, {useState} from 'react';
import Input from "../UI/Input";
import Button from "../UI/Button";

const NewPassword = ({onSubmit, onError, success}) => {

    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onError && onError("");

        if(password === newPassword && password !== "") {
            onSubmit && onSubmit(password);
        } else {
            onError && onError("Le password non corrispondono");
        }
    }

    return (
        <div className="mx-4 p-4 bg-ea_green_from rounded-lg mt-4 flex flex-col ">
            {success ?
                <div>
                    <div className="font-bold">Password cambiata correttamente</div>
                </div>
                :
                <form onSubmit={handleSubmit}>
                    <div className="mb-2">Inserisci la tua nuova password</div>
                    <Input value={password}
                           label="Nuova Password"
                           type="password"
                           placeholder="Nuova password"
                           onChange={e => setPassword(e.target.value)}
                           required />
                    <Input value={newPassword}
                           label="Ripeti password"
                           type="password"
                           placeholder="Ripeti password"
                           onChange={e => setNewPassword(e.target.value)}
                           required />
                    <Button className="text-black mt-6">Conferma password</Button>
                </form>
            }

        </div>
    );
};

export default NewPassword;